export type AvatarDisplay =
  | { type: 'image'; url: string }
  /** First letter of the agent / manager name. */
  | { type: 'label'; text: string }
  | { type: 'default' };

/**
 * Avatar priority:
 * 1. Photo URL
 * 2. First letter of name from settings / thread
 * 3. Generic bot icon (handled in UI)
 */
export function resolveAvatarDisplay(
  avatarUrl: string | null | undefined,
  agentName: string | undefined,
): AvatarDisplay {
  const url = avatarUrl?.trim();
  if (url) {
    return { type: 'image', url };
  }

  const letter = extractAvatarInitial(agentName);
  if (letter) {
    return { type: 'label', text: letter };
  }

  return { type: 'default' };
}

/** First character of the display name (uppercased). */
export function extractAvatarInitial(name: string | undefined): string | null {
  const trimmed = name?.trim();
  if (!trimmed) return null;
  return trimmed.charAt(0).toUpperCase();
}

/** @deprecated Prefer extractAvatarInitial — avatar shows one letter. */
export function extractAvatarNameLabel(name: string | undefined): string | null {
  return extractAvatarInitial(name);
}

/** First letter, or first + last word initial for multi-word names. */
export function extractInitials(name: string | undefined): string | null {
  const trimmed = name?.trim();
  if (!trimmed) return null;

  const words = trimmed.split(/\s+/).filter(Boolean);
  if (words.length === 0) return null;
  if (words.length === 1) {
    return words[0]!.charAt(0).toUpperCase();
  }

  const first = words[0]!.charAt(0);
  const last = words[words.length - 1]!.charAt(0);
  return (first + last).toUpperCase();
}
